<template>
  <a-card v-if="currentProcess === null" :title="taskName" size="small">
    <a-table :columns="processesColumns" :data-source="taskProcesses">
      <template #bodyCell="{ record, column, index }">
        <template v-if="column.dataIndex === 'process'">
          {{ record.name }}
        </template>
        <template v-if="column.dataIndex === 'action'">
          <a-button type="primary" @click="handleCreateSimilarSteps(record)">
            Create Similar Steps
          </a-button>
        </template>
      </template>
    </a-table>
  </a-card>
  <SimilarStepsTable
    v-else
    :current-process="currentProcess"
    @handle-back="handleBackNavigation"
  />
</template>
<script>
import { mapGetters } from 'vuex';
import { processesColumns } from './config';
import SimilarStepsTable from './SimilarStepsTable.vue';
export default {
  components: { SimilarStepsTable },
  setup() {
    return { processesColumns };
  },

  data() {
    return {
      taskProcess: [],
      currentProcess: null,
    };
  },

  computed: {
    ...mapGetters(['taskProcesses', 'taskName']),
  },

  methods: {
    handleCreateSimilarSteps(record) {
      this.currentProcess = record;
    },

    handleBackNavigation() {
      this.currentProcess = null;
    },
  },
};
</script>
